// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M9.8.4L25 15.6c.2.2.4.5.4.9 0 .3-.1.6-.4.9L9.8 32.6c-.3.3-.8.3-1.1 0l-.9-.9c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5l14.1-14.2L7.8 2.4c-.3-.3-.3-.8 0-1.1l.9-.9c.3-.3.8-.3 1.1 0z"/></svg>;
};

export default React.memo(CaretRight);
